import { useLayoutEffect, useEffect, useRef, useState } from "react";

// const defaultColors = [
//   {
//     key: "primaryColor",
//     color: "ffffff",
//     rgbColor: [255, 255, 255],
//   },
//   {
//     key: "secondaryColor",
//     color: "f8f8f8",
//     rgbColor: [248, 248, 248],
//   },
//   {
//     key: "primaryTextColor",
//     color: "2b2b2b",
//     rgbColor: [43, 43, 43],
//   },
//   {
//     key: "secondaryTextColor",
//     color: "ee2424",
//     rgbColor: [238, 36, 36],
//   },
// ];

const COLON = ":";

export const defaultColors = {
  primaryColor: "#ffffff",
  secondaryColor: "#f8f8f8",
  primaryTextColor: "#2b2b2b",
  secondaryTextColor: "#ee2424",
};

const useEnhancedEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

function useChangeColors({
  primaryColor,
  primaryTextColor,
  secondaryColor,
  secondaryTextColor,
} = defaultColors) {
  const ref = useRef(true);
  // console.log(`%c USER CARDS `, `background: ${secondaryTextColor}; color: ${secondaryColor}`);
  // console.log(`%c USER CARDS `, `background: ${secondaryTextColor}; color: ${primaryTextColor}`);

  const [clubColors] = useState(() => {
    const hasNotValidColor = [
      primaryColor,
      primaryTextColor,
      secondaryColor,
      secondaryTextColor,
    ].some((c) => !c);

    if (hasNotValidColor) return;

    return {
      primaryColor,
      primaryTextColor,
      secondaryColor,
      secondaryTextColor,
    };
  });

  // меняем цвета по умолчанию
  useEnhancedEffect(() => {
    if (!ref.current || !clubColors) return; //Object.values(clubColors).some((i) => !i)
    // if (!ref.current) return (ref.current = true);

    const cssStylesList = [];

    for (let key in clubColors) {
      const color = clubColors[key].slice(1);
      const rgbColor = [];

      for (let i = 0; i < color.length; i = i + 2) {
        const colorFragment = color.slice(i, i + 2);

        const intColorFragment = parseInt(colorFragment, 16);

        rgbColor.push(intColorFragment);
      }

      cssStylesList.push(
        `--${key}${COLON} #${color}`,
        `--${key}Rgb${COLON} ${rgbColor.join(", ")}`
      );
    }
    document.documentElement.style.cssText = cssStylesList.join("; ");

    ref.current = false;
  }, [clubColors]);
}

export default useChangeColors;
